<template>
  <div
    class="application form"
  >
    <h2 class="application__title">Pre Registration Forms</h2>

    <div class="pre-reg-form">
      <ApplicationAddRow
        v-for="field in currentForm.preparedFields"
        :ref="field.ref"
        :key="field.id"
        v-show="!field.hidden"
        :fields-data="field"
        :field-value="field.value"
        :valid-tracker="validTracker"
        :check-value="field.hidden"
        :is-disabled-editing="isDisableEditing"
        @checkConditions="checkConditions"
      />
    </div>

    <p class="form__error">{{errorMessage}}</p>

    <div
      v-if="validationErrors.length"
      class="form-group"
    >
      <p
        v-for="(validationError, index) in validationErrors"
        :key="index"
        class="text-center form__error"
      >
        {{ validationError }}
      </p>
    </div>


    <div class="form__row form__one-row">
      <span
        v-if="globalFormTabIndex === 0"
        class="btn btn--color-outline-inactive form__button input-button_left"
      >Previous</span>
      <span
        v-if="globalFormTabIndex > 0"
        class="btn btn--color-outline-dark form__button input-button_left"
        @click="$store.commit('applicationRegistration/DECREMENT_TAB_INDEX')"
      >Previous</span>

      <button
        v-if="editable"
        class="btn btn--color-dark form__button"
        type="button"
        @click="saveForm"
      >Complete Form
      </button>

      <button
        v-else
        class="btn btn--color-outline-inactive form__button"
        type="button"
        @click="skipForm"
      >Next
      </button>
    </div>


    <div class="text-center">
      <button
        v-if="canSkip"
        class="text-muted small btn btn-link"
        @click="skipForm"
      >
        Skip For Now
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'vue-select/dist/vue-select.css'
import ApplicationAddRow from '@/views/Application/ApplicationAddRow.vue'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'

export default {
  components: {
    ApplicationAddRow,
  },
  mixins: [prepareProgramRegistrationInfo],
  props: {
    formIndex: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      role: getUserData()?.role,
      validationErrors: [],
      errorMessage: '',
      validTracker: false,
      isDisableEditing: true,
      isSubmitButtonDisabled: false,
    }
  },
  async created() {
    this.isDisableEditing = this.currentForm?.status === 'Approved' || this.currentForm?.status === 'In Review'
  },
  computed: {
    ...mapGetters({
      formsList: 'preRegistrationForm/getPreRegFormsList',
      manageableUserId: 'preRegistrationForm/getManageableUserId',
      programLink: 'programs/getManageableProgramLink',
    }),
    currentForm() {
      return this.formsList[this.formIndex]
    },
    curTabIndex: {
      get() {
        return this.$store.getters['preRegistrationForm/getCurrentTabIndex']
      },
      set(val) {
        this.$store.commit('preRegistrationForm/SET_CURRENT_TAB_INDEX', val)
      }
    },
    globalFormTabIndex: {
      get() {
        return this.$store.getters['applicationRegistration/getCurrentTabIndex']
      },
      set(val) {
        this.$store.commit('applicationRegistration/SET_TAB_INDEX', val)
      }
    },
    canSkip() {
      return !this.currentForm.is_required && !['Approved', 'In Review'].includes(this.currentForm.status)
    },
    editable() {
      return ['Rejected', 'Not Started', 'To Do'].includes(this.currentForm.status)
    },
  },
  methods: {
    skipForm() {
      // 1. Search required unapproved form behind
      const requiredUnfilledIndex = this.formsList.findIndex((form, index) => {
        return index < this.globalFormTabIndex &&
          form.is_required &&
          form.status !== 'Approved'
      })

      if (requiredUnfilledIndex !== -1) {
        this.globalFormTabIndex = requiredUnfilledIndex
        return
      }

      // 2. Search unfilled form ahead
      const nextIndex = this.formsList.findIndex((form, index) => {
        return index > this.globalFormTabIndex &&
          !['Approved', 'In Review'].includes(form.status)
      })

      if (nextIndex !== -1) {
        this.globalFormTabIndex = nextIndex
        return
      }

      // 3. If all forms already filled
      this.$store.commit('applicationRegistration/INCREMENT_TAB_INDEX')
      this.$emit('nextStep')
    },
    checkConditions() {
      // console.log('checkConditions')
    },
    findCanvasRefForField(field) {
      if (this.$refs[field.ref]) {
        return this.$refs[field.ref][0]?.$refs[`signature_${field.ref}`]?.$refs[field.ref]
      }
      return null
    },
    async validStep() {
      const formFields = this.currentForm.preparedFields

      if (formFields.filter(field => field.required && !['plain_text', 'signature'].includes(field.type) && (field.value == null || field.value.length == 0) && !field.hidden).length > 0 ) {
        this.errorMessage = 'Please, fill required fields'
        this.validTracker = true
        return
      }

      const signatureFields = formFields.filter(field => field.type === 'signature' && field.required && !field.hidden)
      if (signatureFields.length > 0 ) {
        signatureFields.forEach(field => {
          const canvasRef = this.findCanvasRefForField(field)
          if (canvasRef && canvasRef.isEmpty() && !canvasRef.loadedImage) {
            this.errorMessage = 'Please, fill Signature field'
            this.validTracker = true
          }
        })
        if (this.validTracker) {
          return
        }
      }

      this.validTracker = false

      this.errorMessage = ''
      // if (this.curTabIndex < this.formsList.length){
      //   this.curTabIndex += 1
      // }
    },
    uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)

      return store.dispatch('files/uploadFiles', {
        name: `pre-reg-form-files-${new Date().getTime()}`,
        file: formData,
      })
    },
    async saveForm() {
      this.validTracker = false
      await this.validStep()
      if (this.validTracker) return

      store.commit('SET_LOADING_STATUS', true)
      this.isSubmitButtonDisabled = true
      this.errorMessage = ''
      this.validationErrors = []

      let fileFieldsCount = 0
      const queryParams = {
        form_id: this.currentForm.form_id,
        fields: [],
        form_data: {},
        pre_reg_form_id: this.currentForm.id,
        user_id: this.manageableUserId,
      }
      const filesLinks = []
      const filesNames = []

      const formFields = this.currentForm.preparedFields

      if (this.currentForm.hasFileField) {
        const fileFields = formFields.filter(row => ['file_upload'].includes(row.type) && row.value)

        if (fileFields.length > 0) {
          fileFields.forEach(field => {
            Array.from(field.value).forEach(val => {
              if (val instanceof Blob) {
                filesLinks.push(this.uploadFile(val))
              } else {
                filesNames.push(val)
              }
            })
          })
        }
      }

      if (this.currentForm.hasSignatureField) {
        const signatureFields = formFields.filter(row => row.type === 'signature')
        signatureFields.forEach(field => {
          const canvasRef = this.findCanvasRefForField(field)
          if (canvasRef && !canvasRef.isEmpty()) {
            field.signature = canvasRef.save()
          }
        })
      }

      const requests = []
      const fileRequests = filesLinks.map(link => ({ request: link, type: 'file' }))
      requests.push(...fileRequests)

      return Promise.all(requests.map(r => r.request))
        .then(responses => responses.forEach((response, index) => {
          const request = requests[index]

          if (!response.file_path) {
            throw new Error('Error uploading file')
          }

          if (request.type === 'file') {
            filesNames.push(response.file_path)
          }
        }))
        .then(() => {
          formFields
            .filter(row => !row.hidden)
            .forEach(row => {
              if (row.type === 'file_upload' && row.value) {
                let from = fileFieldsCount
                let to = fileFieldsCount + row.value.length
                let sliced = filesNames.slice(from, to)

                queryParams.fields.push({
                  field_id: row.id,
                  files: sliced,
                })
                queryParams.form_data[row.name] = sliced

                fileFieldsCount = to
              } else if (row.type === 'signature' && row.signature) {
                queryParams.fields.push({
                  field_id: row.id,
                  result: row.signature,
                })
                queryParams.form_data[row.name] = row.signature
              } else {
                queryParams.fields.push({
                  field_id: row.id,
                  result: row.value,
                })
                queryParams.form_data[row.name] = row.value
              }
            })

          return store.dispatch('preRegistrationForm/savePreRegFormResult', queryParams)
            .then(response => {
              if (response.status > 400) {
                if (response.status === 422) {
                  const validationErrors = Object.values(response.data.errors)
                  this.validationErrors = validationErrors.flat()
                } else {
                  this.errorMessage = response.data.message
                }
              }
              else {
                const formIndex = this.formsList.findIndex(f => f.id === this.currentForm.id)

                if (formIndex !== -1) {
                  this.$set(this.formsList[formIndex], 'status', response.data.status)
                }
              }

              this.skipForm()
            })
        })
        .catch(error => {
          console.error('Error saving pre-registration form:', error)
          this.errorMessage = error?.message || 'Something went wrong while saving the form. Please try again.'
        })
        .finally(() => {
          store.commit('SET_LOADING_STATUS', false)
          this.isSubmitButtonDisabled = false
        })
    },
  },
}
</script>

<style lang="scss">
  .pre-reg-form {
    margin-top: 30px;
  }
</style>
